import { Fragment, MouseEventHandler, ReactNode } from "react";
import { Menu, Transition } from "@headlessui/react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import Divider from "../../Divider";

interface MenuItem {
  href?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  label: string;
  icon?: ReactNode;
  divider?: ReactNode;
}

interface IProps {
  menuItems: Array<MenuItem>;
  buttonText: string;
  icon?: React.ReactNode;
  styles?: {
    container?: string;
    button?: string;
  };
}

export default function ButtonWithDropdown({
  menuItems = [],
  buttonText = "",
  icon,
  styles = {},
}: IProps): JSX.Element {
  return (
    <div
      className={classNames(
        "sm:ml-6 sm:flex sm:items-center",
        styles.container || ""
      )}
    >
      {/* Profile dropdown */}
      <Menu
        as="div"
        className="relative ml-3"
      >
        <div>
          <Menu.Button className="flex rounded-lg bg-white text-sm focus:outline-none">
            <span className="sr-only">Open user menu</span>
            <div
              className={classNames(
                "px-4 py-2 w-auto rounded-lg flex items-center justify-center font-medium",
                styles.button || ""
              )}
            >
              {buttonText}
              {icon ? icon : null}
            </div>
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-10 mt-2 w-64 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            {menuItems.map((menuItem, index) => {
              // if (menuItem.divider) {
              //   return menuItem.divider;
              // }
              return (
                <Menu.Item key={index}>
                  {menuItem?.href ? (
                    <Link
                      to={menuItem?.href}
                      className={
                        "px-4 py-2 text-sm text-gray-700 flex items-center justify-start hover:bg-gray-100 "
                      }
                      onClick={menuItem?.onClick}
                    >
                      {menuItem.icon || null}
                      {menuItem.label}
                    </Link>
                  ) : (
                    <a
                      className={
                        "px-4 py-2 text-sm text-gray-700 flex items-center justify-start hover:bg-gray-100 cursor-pointer"
                      }
                      onClick={menuItem?.onClick}
                    >
                      {menuItem.icon ?? null}
                      {menuItem.label}
                    </a>
                  )}
                </Menu.Item>
              );
            })}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
